import { error } from '@client/core/utils/logging';

/**
 * A utility class that helps for code-based values presented in a dropdown, or
 * value objects that use a simple key-value pair.
 *
 * This function cannot have a return type since it is privately scoped in the method.
 */
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function Sluggable<T>(config: SluggableOptions = { returnAsIsWhenSlugMissing: false }) {
  abstract class Sluggable implements Slugged {
    public readonly name: string;
    public readonly slug: string;

    constructor({ name, slug }: { name: string; slug: string }) {
      this.name = name;
      this.slug = slug;
    }

    static readonly values: T[] = [];

    static findBySlug(slug: string): T {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const lookup = this.values.find((v) => (v as Sluggable).slug === slug);

      if (!lookup) {
        if (config.returnAsIsWhenSlugMissing) {
          return { name: slug, slug } as T;
        }

        error(`Sluggable - Could not find slug: "${slug}" -- Expected it registered in ${this.name}.`);

        return { name: '', slug: '' } as unknown as T;
      }

      return Object.freeze(lookup);
    }
  }

  return Sluggable;
}

interface SluggableOptions {
  // Set `true` if Users can also enter their own values that should be displayed as-is.
  returnAsIsWhenSlugMissing?: boolean;
}

interface Slugged {
  readonly name: string;
  readonly slug: string;
}
